import { library } from "@fortawesome/fontawesome-svg-core";

import {
	faTelegram as fabTelegram,
} from '@fortawesome/free-brands-svg-icons';
import {
	faPencil as fasPencil,
	faUsers as fasUsers,
	faTrashCan as fasTrashCan,
	faFileContract as fasFileContract,
	faBoxArchive as fasBoxArchive,
	faChevronLeft as fasChevronLeft,
	faChevronRight as fasChevronRight,
	faMagnifyingGlass as fasMagnifyingGlass,
	faSpinner as fasSpinner,
} from "@fortawesome/free-solid-svg-icons";
import {
	faEnvelope as farEnvelope,
} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
	fasPencil,
	fasUsers,
	fasTrashCan,
	fasFileContract,
	fasBoxArchive,
	fasChevronLeft,
	fasChevronRight,
	fasMagnifyingGlass,
	fasSpinner
);

export { FontAwesomeIcon };